<template>
  <div v-if="isExternalLink">
    <a :href="$config.websiteUrl + '/' + storeLink" class="my-5" :class="classList" v-if="fromStore" :target="target ? '_blank' : '_self'">
      <i :class="classIcon"><font-awesome-icon v-if="icon" :icon="icon" /></i>
      {{$t(`nav.${name}`)}}
      <b-badge pill v-if="badge && badge.text" :variant="badge.variant">{{badge.text}}</b-badge>
      <b-badge pill v-if="count" :variant="badge.variant">{{count}}</b-badge>
    </a>
    <a :href="url" v-else :class="classList"  :target="target ? '_blank' : '_self'">
      <i :class="classIcon"><font-awesome-icon v-if="icon" :icon="icon" /></i>
      {{$t(`nav.${name}`)}}
      <b-badge pill v-if="badge && badge.text" :variant="badge.variant">{{badge.text}}</b-badge>
      <b-badge pill v-if="count" :variant="badge.variant">{{count}}</b-badge>
    </a>
  </div>
  <div v-else>
    <router-link :to="url" :class="classList" :target="target ? '_blank' : '_self'">
      <i :class="classIcon"><font-awesome-icon v-if="icon" :icon="icon" /></i>
      {{$t(`nav.${name}`)}}
      <b-badge pill v-if="badge && badge.text" :variant="badge.variant">{{badge.text}}</b-badge>
      <b-badge pill v-if="count" :variant="badge.variant">{{count}}</b-badge>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    target: {
      type: Boolean,
      default: false
    },
    fromStore: {
      type: Boolean
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: () => {}
    },
    variant: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      count: null,
      storeLink: null
    }
  },
  computed: {
    classList () {
      return [
        'nav-link',
        this.linkVariant,
        ...this.itemClasses
      ]
    },
    classIcon () {
      return [
        'nav-icon'
      ]
    },
    linkVariant () {
      return this.variant ? `nav-link-${this.variant}` : ''
    },
    itemClasses () {
      return this.classes ? this.classes.split(' ') : []
    },
    isExternalLink () {
      if (this.url.substring(0, 4) === 'http') {
        return true
      } else {
        return false
      }
    }
  },
  watch:{
    $route () {
      if (this.badge && this.badge.countModel) {
        this.getCount()
      }
    },
    '$store.state.menuEditorLink' (newVal) {
      this.storeLink = newVal
    }
  },
  mounted () {
    if (this.badge && this.badge.countModel) {
      this.getCount()
    }
  },
  methods: {
    getCount () {
      this.$api[this.badge.countModel].count(this.badge.filter).then(res => {
        this.count = res
      })
    }
  }
}
</script>
